import type { UseSearchSharesParams } from './types';

export type UseSearchSharesQueryKey = readonly [
  'search',
  'sharedWithMe',
  UseSearchSharesParams,
];

export const getUseSearchSharesQueryKey = (
  params: UseSearchSharesParams,
): UseSearchSharesQueryKey => ['search', 'sharedWithMe', params];
